import { render, staticRenderFns } from "./UserToolbar.vue?vue&type=template&id=8b72f38a&scoped=true"
import script from "./UserToolbar.vue?vue&type=script&lang=js"
export * from "./UserToolbar.vue?vue&type=script&lang=js"
import style0 from "./UserToolbar.vue?vue&type=style&index=0&id=8b72f38a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b72f38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b72f38a')) {
      api.createRecord('8b72f38a', component.options)
    } else {
      api.reload('8b72f38a', component.options)
    }
    module.hot.accept("./UserToolbar.vue?vue&type=template&id=8b72f38a&scoped=true", function () {
      api.rerender('8b72f38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/UserToolbar.vue"
export default component.exports